module.exports = __webpack_public_path__ + "static/media/access-denied.a448b144.svg";